import React, { Fragment } from "react";
import {
  Typography,
  Container,
  TextField,
  CssBaseline,
  Grid,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  iconButton: {
    padding: 10,
  },
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

export const BrandForm = (props) => {
  const classes = useStyles();
  const { handleChange, brand } = props;

  return (
    <Fragment>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
          <Typography color="primary" component="h4">
            Add Brand
          </Typography>
          <form
            className={classes.form}
            margin="dense"
            noValidate
            autoComplete="off"
          >
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  size="small"
                  required={true}
                  id="outlined-basic"
                  variant="outlined"
                  label="Name: "
                  name="name"
                  value={brand && brand.name}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormControlLabel
                  value="start"
                  control={
                    <Checkbox
                      name="ar_only"
                      value={brand && brand.ar_only}
                      checked={brand && brand.ar_only}
                      onChange={handleChange}
                      color="primary"
                    />
                  }
                  label="Accounts Receivable Only"
                  labelPlacement="end"
                />
              </Grid>
            </Grid>
          </form>
        </div>
      </Container>
    </Fragment>
  );
};
